import React from 'react';
import { Badge, Paper, Tabs } from '@mantine/core';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';
import { thousand } from '../../../utils/format';
import classNames from '../../../utils/classNames';
import { useMediaQuery } from '@mantine/hooks';

export default function Tab({
  data,
  disabled,
  defaultValue,
  onChange,
  type,
  inputProps,
}) {
  const matchesMobile = useMediaQuery('(max-width: 1030px)');

  const _handleOnchange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };
  const renderBadgeInfo = (info) => {
    const infoType = typeof info;
    if(infoType === 'number' && info >= 0){
      return (
        <Badge
          color="red"
          ml={8}
          style={{ textTransform: 'capitalize', fontWeight: '500' }}
          variant="filled"
        >
          {thousand(info)}
        </Badge>
      );
    }else{
      return info && (
        <Badge
          color="red"
          ml={8}
          style={{ textTransform: 'capitalize', fontWeight: '500' }}
          variant="filled"
        >
          {info}
        </Badge>
      );
    }
  };

  return (
    <>
      {inputProps?.label ? (
        <label>
          {inputProps.label}
          {inputProps.required && (
            <span className={styles.withAsterisk}> *</span>
          )}
        </label>
      ) : null}
      <Paper radius="md" withBorder>
        <Tabs
          onChange={_handleOnchange}
          p="2px"
          styles={{
            tabsList: {
              borderBottom: '0',
              display: matchesMobile && 'block',
              justifyContent: 'center',
            },
            tab: {
              padding: '1rem',
              width: 100 / data.length + '%',
            },
            tabLabel:
              type === 'underlined' ? { padding: '1rem 0' } : { padding: '0 0' },
            root: {
              '--tabs-list-border-width': '0px ',
            }
          }}
          value={defaultValue}
        >
          <Tabs.List>
            {data.map((val, idx) => (
              <Tabs.Tab
                className={
                  type === 'default'
                    ? classNames(styles.default, disabled && styles.disabled)
                    : styles.item
                }
                key={val.value + idx} value={val.value}>
                {val.label}
                {renderBadgeInfo(val.info)}
              </Tabs.Tab>
            ))}
          </Tabs.List>
          {
            data.map((contents, idx) => (
              <Tabs.Panel key={contents.value + idx} value={contents.value}>
                {contents.content || null}
              </Tabs.Panel>
            ))
          }
        </Tabs>
      </Paper>
    </>
  );
}

Tab.propTypes = {
  data: PropTypes.array,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  inputProps: PropTypes.object,
  onChange: PropTypes.func,
  type: PropTypes.oneOf(['default', 'underlined']),
};
